import 'slick-carousel';

/**
 * Init sliders
 * @param  { Object } $holder       DOM Element - slider holder
 * @param  { Object } sliderOptions Slider options
 * @return { Void }
 */
export function initSlider($holder, sliderOptions) {
  $holder.slick(sliderOptions);
}



// WEBPACK FOOTER //
// ./../src/assets/js/init-slider.js